import React, { useState, useEffect, useRef } from 'react'
import {localestr} from '../utils.js'
import icon from '../icons.svg' 

const localization = 'uk-UA';

export default function EditDateTime({title,Value,setVal,disabled=false,style=undefined,id=undefined}){
    const [currVal, setNewVal] = useState(Value?(new Date(Value)).toLocaleString(localization).replace(',',''):'')
    const [showDlg, setShow] = useState(0);
    const [currMn, setMn] = useState();
    const [currYr, setYr] = useState();
    const [currTm, setTm] = useState();
    const [selYr, setYr2] = useState();
    const [mode, setMode] = useState(1);

    const node = useRef(null);
    const inp = useRef(null);

    const uid=id||'dat_div'

    function changeHandler(e){
        setShow(0)
        let val=e.target.value
        let pos=e.target.selectionStart
        let is_del=val.length<currVal.length
        if(!val.length){
            setNewVal('')
            return
        }
        if(val.length===pos&&is_del){
            if(val.length>2&&val[val.length-1]==='.') val=val.substring(0,val.length-1)
            setNewVal(val)
            return
        }
        if(pos>5&&is_del){
            setNewVal(val)
            return
        }
        if(!is_del) pos--
        let symb=val[pos]
        if(symb===',') symb='.'
        if(is_del) symb=currVal[pos]
        let bc=false
        let valid=true
        if(is_del) bc=e.nativeEvent.inputType==='deleteContentBackward'
        else if(pos>18) return
        const ch_code=symb.charCodeAt(0)
        if(is_del){
            val=currVal.substring(0, pos)+' '+currVal.substring(pos+1)
            if(pos===2&&symb==='.') val=currVal
            if(pos===5&&symb==='.') val=currVal
            if(!bc) pos++
        } else if((pos===2&&symb!=='.')||(pos===5&&symb!=='.')){
            val=currVal.substring(0, pos)+'.'+symb+currVal.substring(pos)
            pos++
        } else if(pos===10&&symb!==' '){
            val=currVal.substring(0, pos)+' '+symb+currVal.substring(pos)
            pos++
        } else if((pos===13&&symb!==':')||(pos===16&&symb!==':')){
            val=currVal.substring(0, pos)+'.'+symb+currVal.substring(pos)
            pos++
        }
        if(ch_code<48) valid=false
        else if(ch_code>57) valid=false
        else if(pos===0&&ch_code>51) valid=false
        else if(pos===3&&ch_code>49) valid=false
        else if(pos===11&&ch_code>50) valid=false
        else if(pos===14&&ch_code>53) valid=false
        else if(pos===17&&ch_code>53) valid=false
        if(pos+1<val.length) {
            val=currVal.substring(0, pos)+symb+currVal.substring(pos+1)
            is_del=true
            pos++
        } else if(val.length===2||val.length===5) val+='.'
        else if(val.length===10) val+=' '
        else if(val.length===13||val.length===16) val+=':'
        if(val.length>5&&parseInt(val.substring(3,5))>12) valid=false
        if(val.length>12&&parseInt(val.substring(11,13))>23) valid=false
        if(valid) {
            if(val.length>2&&parseInt(val.substring(0,2))>31) val='31'+val.substring(2)
            setNewVal(val)
        }
        if(is_del) setTimeout(()=>{e.target.selectionStart=pos;e.target.selectionEnd=pos},10)
        return
    }

    function validateDate(e){
        const dt=currVal.split(' ')
        const arrD = dt[0].split('.')
        arrD[1] -= 1
        if(arrD[2]&&parseInt(arrD[2])<100) arrD[2]=2000+parseInt(arrD[2])
        else if(!arrD[2]) arrD[2]=(new Date()).getFullYear()
        let curTime='00:00:00'
        if(dt[1]) curTime=dt[1]
        const arrT = curTime.split(':')
        const d = new Date(arrD[2], arrD[1], arrD[0],arrT[0]||0,arrT[1]||0,arrT[2]||0)
        if ((d.getFullYear() === parseInt(arrD[2])) && (d.getMonth() === parseInt(arrD[1])) && (d.getDate() === parseInt(arrD[0]))) {
            setNewVal(d.toLocaleString(localization).replace(',',''))
            if(setVal) setVal(d)
            e.target.style.color='inherit'
        } else {
            if(currVal) e.target.style.color='red'
            inp.current.focus()
        }
    }

    function showCal(){
        if(!currVal){
            const d = new Date()
            setShow(disabled?false:true)
            setMn(d.getMonth())
            setYr(d.getFullYear())
            setTm('00:00:00')
            return
        }
        const dt=currVal.split(' ')
        const arrD = dt[0].split('.')
        arrD[1] -= 1
        if(arrD[2]&&parseInt(arrD[2])<100) arrD[2]=2000+parseInt(arrD[2])
        let curTime='00:00:00'
        if(dt[1]) curTime=dt[1]
        const arrT = curTime.split(':')
        const d = new Date(arrD[2], arrD[1], arrD[0],arrT[0]||0,arrT[1]||0,arrT[2]||0)
        if ((d.getFullYear() === parseInt(arrD[2])) && (d.getMonth() === parseInt(arrD[1])) && (d.getDate() === parseInt(arrD[0]))) {
            setShow(disabled?false:true)
            setNewVal(d.toLocaleString(localization).replace(',',''))
            setMn(arrD[1])
            setYr(arrD[2])
            setTm(curTime)
            setMode(1)
        } else {
            setShow(0)
        }
    }

    function Paint(){
        if(mode===2 || mode===4){
            const mn=[[{name:localestr('Січень'),val:0},{name:localestr('Липень'),val:6}],
                    [{name:localestr('Лютий'),val:1},{name:localestr('Серпень'),val:7}],
                    [{name:localestr('Березень'),val:2},{name:localestr('Вересень'),val:8}],
                    [{name:localestr('Квітень'),val:3},{name:localestr('Жовтень'),val:9}],
                    [{name:localestr('Травень'),val:4},{name:localestr('Листопад'),val:10}],
                    [{name:localestr('Червень'),val:5},{name:localestr('Грудень'),val:11}]]
            const stl={width:'84px',textAlign:'center',lineHeight:'24px',cursor:'pointer'}
            const arrD = currVal.split(".")
            arrD[1] -= 1
            if(arrD[2]&&parseInt(arrD[2])<100) arrD[2]=2000+parseInt(arrD[2])
            return(
                mn.map(((d1,x)=>{
                    return(<div key={x} style={{display:'flex'}}>{d1.map((d2,y)=>{
                        if(d2.val===arrD[1] && parseInt(currYr)===parseInt(arrD[2])) return(<div className='hilight' key={x+'-'+y} style={{...stl,color:'blue'}} onClick={()=>{setMn(d2.val);setMode(1)}}>{d2.name}</div>)
                        return(<div className='hilight' key={x+'-'+y} style={stl} onClick={()=>{setMn(d2.val);setMode(1)}}>{d2.name}</div>)
                    })}</div>)
                }))
            )
        }
        if(mode===3){
            const yr=[]
            const start=selYr-9
            for(let i=0;i<6;i++){
                yr.push([])
                for(let k=0;k<3;k++){
                    yr[i].push(start+i+k*6)
                }
            }
            const stl={width:'56px',textAlign:'center',lineHeight:'24px',cursor:'pointer'}
            const arrD = currVal.split(".")
            arrD[1] -= 1
            if(arrD[2]&&parseInt(arrD[2])<100) arrD[2]=2000+parseInt(arrD[2])
            return(
                yr.map(((d1,x)=>{
                    return(<div key={x} style={{display:'flex'}}>{d1.map((d2,y)=>{
                        if(d2===parseInt(arrD[2])) return(<div className='hilight' key={x+'-'+y} style={{...stl,color:'blue'}} onClick={()=>{setYr(d2);setMode(4)}}>{d2}</div>)
                        return(<div className='hilight' key={x+'-'+y} style={stl} onClick={()=>{setYr(d2);setMode(4)}}>{d2}</div>)
                    })}</div>)
                }))
            )
        }
        const arrT = currTm.split(':')
        let DCurr=new Date(currYr,currMn,-6,arrT[0]||0,arrT[1]||0,arrT[2]||0)
        let DStop=new Date(currYr,currMn+1,7)
        let show=false
        let data=[[localestr('Пн'),localestr('Вт'),localestr('Ср'),localestr('Чт'),localestr('Пт'),localestr('Сб'),localestr('Нд')]]
        let idx=0
        while(DCurr<DStop){
            if((DCurr.getMonth()<=currMn||DCurr.getFullYear()<=currYr)&&DCurr.getDay()===1) show=true
            if(((DCurr.getFullYear()===parseInt(currYr)&&DCurr.getMonth()>currMn)||DCurr.getFullYear()>currYr)&&DCurr.getDay()===1) show=false
            if(show){
                const day=DCurr.getDay()
                if(day===1) {idx++;data.push([null,null,null,null,null,null,null])}
                if(day===0) data[idx][6]={name:DCurr.getDate(),val:DCurr.toISOString(),val2:DCurr.toLocaleString(localization).replace(',',''),curr:DCurr.getMonth()===currMn}
                else data[idx][day-1]={name:DCurr.getDate(),val:DCurr.toISOString(),val2:DCurr.toLocaleString(localization).replace(',',''),curr:DCurr.getMonth()===currMn}
                //console.log(DCurr)
            }
            DCurr.setDate(DCurr.getDate()+1)

        }
        //console.log(data)
        const stl={width:'24px',textAlign:'center',lineHeight:'24px',cursor:'pointer'}
        return(
            data.map((d1,x)=>{
                return(<div key={x} style={{display:'flex'}}>{d1.map((d2,y)=>{
                    if(!x) return(<div key={x+'-'+y} style={{width:'24px',textAlign:'center',color:'#0008'}}>{d2}</div>)
                    if(d2.val2.substring(0,10)===currVal.substring(0,10)) return(<div className='hilight' key={x+'-'+y} style={{...stl,color:'blue'}} onClick={()=>{setNewVal(d2.val2);setShow(0);if(setVal) setVal(new Date(d2.val))}}>{d2.name}</div>)
                    if(!d2.curr) return(<div className='hilight' key={x+'-'+y} style={{...stl,color:'#0008'}} onClick={()=>{setNewVal(d2.val2);setShow(0);if(setVal) setVal(new Date(d2.val))}}>{d2.name}</div>)
                    if(y===6) return(<div className='hilight' key={x+'-'+y} style={{...stl,color:'#c00'}} onClick={()=>{setNewVal(d2.val2);setShow(0);if(setVal) setVal(new Date(d2.val))}}>{d2.name}</div>)
                    return(<div className='hilight' key={x+'-'+y} style={stl} onClick={()=>{setNewVal(d2.val2);setShow(0);if(setVal) setVal(new Date(d2.val))}}>{d2.name}</div>)
                })}</div>)
            })
        )

    }

    function addMn(cnt){
        const d = new Date(currYr,currMn+cnt,1)
        setMn(d.getMonth())
        setYr(d.getFullYear())
}

    function caption(){
        if(mode===2 || mode===4){
            return(<div style={{display:'flex',justifyContent:'space-between',padding:'4px 0', borderBottom:'1px solid #0001',lineHeight:'24px'}}>
                <div className='hilight' style={{width:'24px',textAlign:'center',color:'#0004',fontWeight:'bold',cursor:'pointer'}} onClick={()=>addMn(-12)}>&lt;</div>
                <div className='hilight' style={{cursor:'pointer',padding:'0 6px'}} onClick={()=>{if(mode===4) setMode(1); else setMode(mode+1);setYr2(parseInt(currYr))}}>{currYr}</div>
                <div className='hilight' style={{width:'24px',textAlign:'center',color:'#0004',fontWeight:'bold',cursor:'pointer'}} onClick={()=>addMn(12)}>&gt;</div>
            </div>)
        }

        if(mode===3){
            return(<div style={{display:'flex',justifyContent:'space-between',padding:'4px 0', borderBottom:'1px solid #0001',lineHeight:'24px'}}>
                <div className='hilight' style={{width:'24px',textAlign:'center',color:'#0004',fontWeight:'bold',cursor:'pointer'}} onClick={()=>setYr2(selYr-10)}>&lt;</div>
                <div className='hilight' style={{cursor:'pointer',padding:'0 6px'}} onClick={()=>{setMode(mode+1)}}>{selYr-9} - {selYr+8}</div>
                <div className='hilight' style={{width:'24px',textAlign:'center',color:'#0004',fontWeight:'bold',cursor:'pointer'}} onClick={()=>setYr2(selYr+10)}>&gt;</div>
            </div>)
        }

        const mn=[localestr('Січень'),localestr('Лютий'),localestr('Березень'),localestr('Квітень'),localestr('Травень'),localestr('Червень'),localestr('Липень'),localestr('Серпень'),localestr('Вересень'),localestr('Жовтень'),localestr('Листопад'),localestr('Грудень')]
        return(<div style={{display:'flex',justifyContent:'space-between',padding:'4px 0', borderBottom:'1px solid #0001',lineHeight:'24px'}}>
            <div className='hilight' style={{width:'24px',textAlign:'center',color:'#0004',fontWeight:'bold',cursor:'pointer'}} onClick={()=>addMn(-1)}>&lt;</div>
            <div className='hilight' style={{cursor:'pointer',padding:'0 3px'}} onClick={()=>{setMode(mode+1)}}>{mn[currMn]} {currYr}</div>
            <div className='hilight' style={{width:'24px',textAlign:'center',color:'#0004',fontWeight:'bold',cursor:'pointer'}} onClick={()=>addMn(1)}>&gt;</div>
        </div>)
    }

    function time(){
        if(mode!==1) return null
        const arrT = currTm.split(':')
        let h=''+(arrT[0]||'00')
        if(h.length<2) h='0'+h
        let m=''+(arrT[1]||'00')
        if(m.length<2) m='0'+m
        let s=''+(arrT[2]||'00')
        if(s.length<2) s='0'+s
        let DCurr=h+':'+m+':'+s
        return(
            <div style={{display:'flex',flexDirection:'column',padding:'4px 0',borderTop:'1px solid #0001',textAlign:'center'}}>
                <div style={{fontWeight:'bold'}}>{DCurr}</div>
                <input type="range" name="hrs" value={arrT[0]||0} min="0" max="23" step="1" onChange={e=>setTm(e.target.value+':'+m+':'+s)} />
                <input type="range" name="min" value={arrT[1]||0} min="0" max="59" step="1" onChange={e=>setTm(h+':'+e.target.value+':'+s)} />
                <input type="range" name="sec" value={arrT[2]||0} min="0" max="59" step="1" onChange={e=>setTm(h+':'+m+':'+e.target.value)} />
            </div>
        )
    }

    useEffect(()=>{
        const listener = (event) =>{
            if(event.target.id===uid) setShow(0)
            if (node.current && event.target && node.current.contains(event.target)) return
            setShow(0)
            } 
        if (showDlg) document.addEventListener("mousedown", listener)
        return () => {document.removeEventListener("mousedown", listener)}
    })

  useEffect(() => {
    setNewVal(Value?(new Date(Value)).toLocaleString(localization).replace(',',''):'')
  }, [Value])

    if(showDlg)
        return(
            <div id={uid} ref={node} style={{...style,display:'inline-flex',position:'relative'}} onKeyUp={()=>{}}>
                <input title={title} ref={inp} style={{width:'calc(100% - 26px)',padding:'0 22px 0 2px',flexShrink:'0',fontSize:'inherit',fontFamily:'inherit'}} type='text' value={currVal||''} 
                disabled={disabled}
                placeholder={(new Date()).toLocaleDateString(localization)}
                onChange={(e)=>{changeHandler(e)}} 
                onBlur={(e)=>{validateDate(e)}} />
                <img className='no-print' style={{marginLeft:'-26px',width:'24px',height:'24px',cursor:'pointer',opacity:disabled?0.5:1}} src={icon+'#cal'} alt='' onClick={()=>{setShow(false)}}/>
                <div style={{right:'2px',top:'24px',position:'absolute',background:'#FFFFFF',padding:'3px',boxShadow:'#0002 0px 5px 7px',zIndex:999}}>
                    {caption()}{Paint()}{time()}
                </div>
            </div>
        )
    else 
        return(
            <div id={uid} ref={node} style={{...style,display:'inline-flex'}} onKeyUp={()=>{}}>
                <input title={title} ref={inp} style={{width:'calc(100% - 26px)',padding:'0 22px 0 2px',flexShrink:'0',fontSize:'inherit',fontFamily:'inherit'}} type='text' value={currVal||''} 
                disabled={disabled}
                placeholder={(new Date()).toLocaleDateString(localization)}
                onChange={(e)=>{changeHandler(e)}} 
                onBlur={(e)=>{validateDate(e)}} />
                <img className='no-print' style={{marginLeft:'-26px',width:'24px',height:'24px',cursor:'pointer',opacity:disabled?0.5:1}} src={icon+'#cal'} alt='' onClick={()=>{showCal()}}/>
            </div>
        )
}